import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Menu } from '@/ui';

export const StyledWrapper = styled.div`
  padding: 0.75rem;
  background-color: ${COLORS.GRAY_LIGHT};
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  border-radius: 0.5rem;
  width: 100%;
`;

export const StyledMenu = styled(Menu)`
  width: 100%;
`;

export const FormItemContainer = styled.div`
  width: 100%;
`;
